import { createResponsePage } from '../survey/SurveyResponsePage';

/**
 * One after-signup survey response, as a page (`/signup-survey-response/:responseId`).
 *
 * A sibling of the Survey Responses page, not a mode of it — the same reason the two tabs are
 * siblings. Everything structural is shared through `createResponsePage`; what is named here is
 * only what actually differs: this survey's endpoint, its way back, and the four derived answers
 * worth putting beside the member's name.
 *
 * The scales are printed with them ("2 / 5", "7 / 10") exactly as the list column does. A bare
 * "2" reads as bad news on a 1–5 scale and as good news on a 1–10 one, and this page is read by
 * someone about to give the member fifteen days of Premium.
 */
export default createResponsePage({
  endpoint: '/admin/api/signup-survey-responses',
  backTo: '/user-feedback?tab=signup-survey',
  backLabel: 'Back to 15 Day Trial Feedback',
  breadcrumb: 'Feedback / 15 Day Trial Feedback',
  route: '/signup-survey-response',
  grantSource: 'after_signup_survey',
  promise: '15 days of Premium',
  // This survey's four derived answers are read where they were asked, in the answer list —
  // they were restated as tiles above it for a day and said the same thing twice.
  // The scored ones are drawn as meters over their own scales.
  scales: { q3_setup_ease: 5, q5_keep_using: 10 },
});
